/**
 * Hand-written because the page needs the whole itinerary in one round trip:
 * package -> days -> items -> option groups -> options. Amplify's generated
 * queries only nest one level, which would mean a request per day item.
 */
export const getStayPackageBySlug = /* GraphQL */ `
  query GetStayPackageBySlug($slug: String!) {
    listStayPackages(filter: { slug: { eq: $slug }, isActive: { eq: true } }, limit: 1) {
      items {
        id
        slug
        name
        tagline
        summary
        nights
        days
        startsOn
        price
        priceUnit
        childPrice
        childFreeUnderAge
        childMaxAge
        childRatePercent
        minGuests
        maxGuests
        inclusions
        images
        heroImage
        mealChoiceCutoffDays
        minNoticeDays
        maxAdvanceMonths
        depositPercent
        dayVisitTiers
        itineraryDays {
          items {
            id
            dayIndex
            role
            title
            subtitle
            items {
              items {
                id
                kind
                sortOrder
                timeLabel
                title
                body
                fixedItems
                note
                optionGroups {
                  items {
                    id
                    label
                    helpText
                    sortOrder
                    required
                    perGuest
                    options {
                      items {
                        id
                        label
                        description
                        sortOrder
                        isVeg
                        containsEgg
                        surcharge
                        isAvailable
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const listActiveStayPackages = /* GraphQL */ `
  query ListActiveStayPackages {
    listStayPackages(filter: { isActive: { eq: true } }) {
      items {
        id
        slug
        name
        tagline
        summary
        nights
        days
        price
        priceUnit
        heroImage
        displayOrder
      }
    }
  }
`;

export const createBookingMutation = /* GraphQL */ `
  mutation CreateFarmStayBooking($input: CreateBookingInput!) {
    createBooking(input: $input) {
      id
      bookingNumber
      status
    }
  }
`;

export const createBookingMealChoiceMutation = /* GraphQL */ `
  mutation CreateBookingMealChoice($input: CreateBookingMealChoiceInput!) {
    createBookingMealChoice(input: $input) {
      id
    }
  }
`;

/** Which nights are already taken. Publicly readable by design: it carries a
 *  date and a coarse reason and nothing else, so a guest can be shown what is
 *  unavailable without any booking being exposed. */
export const listStayAvailability = /* GraphQL */ `
  query ListStayAvailability($packageId: ID!) {
    listStayDateBlocks(filter: { packageId: { eq: $packageId } }, limit: 400) {
      items { id date reason }
    }
  }
`;

/** Real farm photography for the landing page. */
export const listFarmPhotos = /* GraphQL */ `
  query ListFarmPhotos {
    listGalleryImages(limit: 40) {
      items { id originalUrl thumbnailUrl altText caption order }
    }
  }
`;
